import DocumentUpload from '@/app/common/components/DocumentUpload';
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx';
import { AppRoutePaths } from '@/routing/route_paths';
import { useTranslation } from 'react-i18next';
import { useWizardContext } from './StudentDetailsWizardProvider';
import { useNavigate } from 'react-router-dom'

export const StudentCapturePage = () => {
  const { t: translate } = useTranslation()
  const { updateFormData, formData } = useWizardContext()
  const navigate = useNavigate()
  const uploadImage = (file: File) => {
    updateFormData('DateOfBirthFile' as keyof typeof formData, file)
    navigate(AppRoutePaths.family_application.student_details.photo_review)
  }
  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1 id="page-title">{translate('upload_birth_certificate')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="w-full">
        <div
          className="flex-grow flex flex-col items-center justify-center"
          onDragOver={(e) => e.preventDefault()}
        >
          <DocumentUpload
            onUpload={(file) => uploadImage(file[0])}
          />
        </div>
      </FamilyWizardLayout.Content>
    </FamilyWizardLayout>
  )
}
